import axios from '~/util/axios'

export default {
  shareAppBySms (phone, code, slug = 'share_app_sms') {
    var postData = `code=${code}&input[phone_number]=${phone}&input[access_code]=${code}&input[message_slug]=${slug}`
    return axios.get('/install/send_sms?' + postData, {})
  }
}
